import {ApiV0} from '../../api.v0';
import {RestApiService} from '../../../rest-api.service';
import {Observable} from 'rxjs';
import {BugCreateReq, BugCreateRes} from '../../../../contracts/v0/core/bug-create-req';

export class ApiV0Tickets {
    segment = '/tickets';

    // @ts-ignore
    constructor(v0: ApiV0, private rest: RestApiService) {
        this.segment = v0.segment + this.segment;
    }

    createTicket(dto: BugCreateReq): Observable<BugCreateRes> {
        return this.rest.post<BugCreateReq, BugCreateRes>(
            `${this.segment}/`,
            BugCreateRes,
            dto
        );
    }

}